module.exports = __webpack_public_path__ + "static/media/8-AirHeatExchanger - Water cool - No heat.19124a26.png";